module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/main-visual_american-village-767d5381ab3f28af9e4147c7a3e88269.jpg";